type Errors = { [key: string]: string };

export class ErrorParser {
  private errorMap: Errors = {};

  public static parse(errors: Errors) {
    return new ErrorParser().parse(errors);
  }

  private parse(errors: { [key: string]: string }) {
    for (const key in errors) {
      if (!errors.hasOwnProperty(key)) {
        continue;
      }

      this.flatError(key, errors);
    }

    return this.errorMap;
  }

  private flatError(key: string, errors: any, keys: string[] = []) {
    keys.push(key);

    if (Array.isArray(errors[key])) {
      this.errorMap[keys.join('.')] = errors[key];

      return;
    }

    for (const currentKey in errors[key]) {
      if (!errors[key].hasOwnProperty(currentKey)) {
        continue;
      }

      this.flatError(currentKey, errors[key], keys.slice());
    }
  }
}



// WEBPACK FOOTER //
// /dist/src/app/import/import-error/error.parser.ts